import { SettingsClient } from './SettingsClient';
import { HttpClient } from 'config/apiFunus/generated/http-client';
import axiosInstance from 'config/axios';

const httpClient = new HttpClient();
httpClient.instance = axiosInstance;

export const settingsController = new SettingsClient(httpClient);
